import { Card } from "../Card/Card";
import { Coin } from "../../Coin/Coin";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import Utility from "../../Utility/Utility";
import styles from "./SmallCard.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SmallCard = function SmallCard(_ref) {
  var onClick = _ref.onClick,
    _ref$link = _ref.link,
    link = _ref$link === void 0 ? '' : _ref$link,
    _ref$newWindow = _ref.newWindow,
    newWindow = _ref$newWindow === void 0 ? false : _ref$newWindow,
    title = _ref.title,
    personalPoints = _ref.personalPoints,
    image = _ref.image,
    _ref$cardActionAttrib = _ref.cardActionAttributes,
    cardActionAttributes = _ref$cardActionAttrib === void 0 ? {} : _ref$cardActionAttrib;
  var renderTop = function renderTop() {
    var oneX = image ? Utility.getOptimizedCloudinaryUrl(image, {
      width: 385
    }) : '';
    return /*#__PURE__*/_jsx("div", {
      className: styles.smallCardImage,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.smallCardImageBackground,
        children: oneX && /*#__PURE__*/_jsx("img", {
          src: oneX,
          alt: "",
          className: styles.smallCardImageContent,
          loading: "lazy"
        })
      })
    });
  };
  var renderPersonalPoints = function renderPersonalPoints() {
    var _ref2 = personalPoints || {},
      value = _ref2.value,
      secondValue = _ref2.secondValue,
      label = _ref2.label;
    return /*#__PURE__*/_jsx("div", {
      className: styles.smallCardCoinContainer,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.smallCardCoin,
        children: /*#__PURE__*/_jsx(Coin, {
          size: "small",
          value: value,
          secondValue: secondValue,
          label: label
        })
      })
    });
  };
  var renderBottom = function renderBottom() {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.smallCard,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.smallCardText,
        children: /*#__PURE__*/_jsx(HeadingText, {
          align: "left",
          ariaLevel: 3,
          typog: "bodycopy",
          className: styles.smallCardTitle,
          children: title
        })
      }), personalPoints && typeof personalPoints.value === 'number' && renderPersonalPoints()]
    });
  };
  return /*#__PURE__*/_jsx(Card, {
    bottom: renderBottom(),
    link: link,
    top: renderTop(),
    dropShadow: true,
    onClick: onClick,
    newWindow: newWindow,
    cardActionAttributes: cardActionAttributes
  });
};